<ng-container *ngIf="dialogState === 'DEFAULT'" class="default-container">
    <div mat-dialog-content data-automation="exitDialog">
        <ng-container data-automation="dialogText">
            <span class="dialog-title" data-automation="dialogTitle">{{
                'user.dialog.exit_create.title' | translate
            }}</span>
            <div class="title-separator"></div>
            <div class="dialog-text-container" data-automation="dialogTextContainer" *ngIf="!isCreated">
                <span>{{ 'user.dialog.exit_create.subtitle' | translate }}<br /></span>
                <span>{{ 'user.dialog.exit_create.text' | translate }}</span>
            </div>
            <div class="dialog-text-container" *ngIf="isCreated">
                <span
                    >{{ 'user.dialog.exit_create.subtitle_detailed' | translate }} {{ currentSection | translate }}<br
                /></span>
                <span>{{ 'user.dialog.exit_create.text_detailed' | translate }}</span>
            </div>
        </ng-container>
    </div>
    <div mat-dialog-actions data-automation="buttonsBlock">
        <button
            class="x-btn-secondary dialog-secondary"
            aria-label="Cancel"
            data-automation="dialogCancel"
            (click)="onNoClick()"
        >
            <span>{{ 'user.button.cancel' | translate }}</span>
        </button>

        <button
            class="x-btn-primary dialog-primary"
            aria-label="Update"
            data-automation="dialogLeave"
            (click)="onClick()"
        >
            <span>{{ 'user.button.leave' | translate }}</span>
        </button>
    </div>
</ng-container>
